var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.46745 16.2241C4.51745 16.2241 4.56745 16.2191 4.61745 16.2116L8.82245 15.4741C8.87245 15.4641 8.91995 15.4416 8.95495 15.4041L19.5525 4.80662C19.5756 4.78349 19.594 4.75602 19.6066 4.72578C19.6191 4.69553 19.6256 4.66311 19.6256 4.63037C19.6256 4.59763 19.6191 4.56521 19.6066 4.53497C19.594 4.50472 19.5756 4.47725 19.5525 4.45412L15.3975 0.296621C15.35 0.249121 15.2875 0.224121 15.22 0.224121C15.1525 0.224121 15.09 0.249121 15.0425 0.296621L4.44495 10.8941C4.40745 10.9316 4.38495 10.9766 4.37495 11.0266L3.63745 15.2316C3.61313 15.3655 3.62182 15.5034 3.66277 15.6332C3.70372 15.763 3.77569 15.8809 3.87245 15.9766C4.03745 16.1366 4.24495 16.2241 4.46745 16.2241ZM6.15245 11.8641L15.22 2.79912L17.0525 4.63162L7.98495 13.6966L5.76245 14.0891L6.15245 11.8641ZM20.025 18.3241H1.62495C1.18245 18.3241 0.824951 18.6816 0.824951 19.1241V20.0241C0.824951 20.1341 0.914951 20.2241 1.02495 20.2241H20.625C20.735 20.2241 20.825 20.1341 20.825 20.0241V19.1241C20.825 18.6816 20.4675 18.3241 20.025 18.3241Z",
    fill: "black",
    fillOpacity: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditb);
export default __webpack_public_path__ + "static/media/editb.e003e3e2d6ea958d917a238d03e1526a.svg";
export { ForwardRef as ReactComponent };